<template>
  <div class="container py-4" style="max-width: 480px;">
    <div class="d-flex align-items-center mb-4">
      <button class="btn btn-link text-dark p-0 me-3" @click="$router.go(-1)">
        <i class="bi bi-arrow-left fs-4"></i>
      </button>
      <h5 class="m-0 fw-bold">Manage Subscriptions</h5>
    </div>

    <h6 class="mb-3">Subscription Plans</h6>

    <b-overlay :show="loading">
      <div v-for="(item, index) in listData" :key="index" class="card border-0 shadow-sm text-center p-4 mb-5"
        style="background: linear-gradient(180deg, #dcefff 0%, #ffffff 100%); border-radius: 20px;">

        <h5 class="fw-bold text-dark mb-2">{{ item.plan_title }}</h5>
        <h3 class="fw-bold mb-2">{{ item.plan_duration }} Months</h3>
        <p class="fs-4 fw-bold text-dark mb-4">BDT {{ item.plan_price }}</p>

        <div type="button" class="text-decoration-none text-secondary mb-3 d-block small"
          @click="showBenefits = !showBenefits"> {{ showBenefits ? 'Hide' : 'Show' }} Benefits</div>

        <div v-if="showBenefits">
          <p v-html="item.plan_benefits"></p>
        </div>

        <button @click="goToPayment(item.id)" class="btn btn-dark w-75 rounded-pill py-2 mx-auto d-block">
          Subscribe
        </button>
      </div>
    </b-overlay>

    <h6 class="mb-3" v-if="mySubscriptionList && mySubscriptionList.length">My Subscriptions</h6>

    <b-overlay :show="subscriptionLoading">
      <div v-for="(item, index) in mySubscriptionList" :key="index" class="card border-0 shadow-lg text-center p-4 mb-5 text-white position-relative overflow-hidden"
        style="background: linear-gradient(135deg, #B8860B 0%, #FFD700 50%, #B8860B 100%); border-radius: 20px; min-height: 250px;">

        <div class="d-flex align-items-center justify-content-between mb-4 position-relative">
          <div class="d-flex align-items-center">
            <div class="me-3" style="font-size: 48px; color: rgba(255,255,255,0.8);">
              <i class="ri-star-fill"></i>
            </div>
            <div class="text-left">
              <h4 class="fw-bold text-white mb-1">{{ item?.subcription_plan?.plan_title }}</h4>
              <!-- <p class="mb-1 fw-semibold">Status: <span class="badge bg-success">Active</span></p> -->
              <p class="mb-1 fw-semibold">Status: <span :class="`badge bg-${item.active ? 'success' : 'danger'}`">{{ item.active ? 'Active': 'Inactive' }}</span></p>
              <p class="mb-0 fw-semibold">Expires: {{ dDate(item?.expire_at) }}</p>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center" style="width: 70px; height: 70px; background-color: rgba(255,255,255,0.9); border-radius: 50%; box-shadow: 0 4px 8px rgba(0,0,0,0.2);">
            <img :src="`${baseURL}/images/tax-guru-logo.png`" alt="Payment" class="img-fluid" style="height: 50px; width: 50px;">
          </div>
        </div>

        <div class="text-center mb-3">
          <button @click="showBenefits = !showBenefits" class="btn btn-outline-light text-white rounded-pill py-2 px-4 fw-semibold transition-all" style="border-width: 2px;">
            <i class="ri-star-fill me-1"></i> {{ showBenefits ? 'Hide' : 'Show' }} Benefits
          </button>
        </div>

        <div v-if="showBenefits" class="mt-3 p-3 " style="background-color: rgba(255, 255, 255, 0.2); border-radius: 15px;">
          <p v-html="item?.subcription_plan?.plan_benefits" class="text-white mb-0"></p>
        </div>

      </div>
    </b-overlay>

    <div class="text-right mb-3" v-if="mySubscriptionList && mySubscriptionList.length">
      <button @click="$router.push({ name: 'UserBillingHistory' })" class="btn btn-dark text-white rounded-pill py-2 px-4 fw-semibold transition-all" style="border-width: 2px;">
        View Billing History
      </button>
    </div>

    <!-- <div class="text-center mt-5">
      <a href="#" class="text-warning text-decoration-none small">View Billing History</a>
    </div> -->
  </div>
</template>

<script>
// import RestApi, { baseURL, apiBaseURL } from '@/config'
import RestApi, { baseURL, apiBaseURL } from '@/config'

export default {
  data () {
    return {
      baseURL,
      value: '',
      showBenefits: false,
      listData: [],
      mySubscriptionList: [],
      loading: false,
      subscriptionLoading: false,
      editItem: '',
      token: this.$route.query.token || '' // Get from URL or default
    }
  },
  created () {
    console.log('Token:', this.token)
    if (!localStorage.getItem('access_token')) {
      const token = this.$route.query.token || ''
      if (token) {
        // this.form.token = token
        localStorage.setItem('access_token', token)
        localStorage.setItem('api_token', token)
        this.$store.dispatch('Auth/setAccessToken', token)
      }
    }
    this.loadData()
    this.getMySubscriptionList()
  },
  methods: {
    async loadData () {
      this.loading = true
      try {
        // var { data } = await RestApi.getData(baseURL, 'ios/getSubscriptionPlanList')
        var { data } = await RestApi.getData(apiBaseURL, 'admin/ajax/get_subscription_plan_list_for_ios')
        // console.log('Subscription Plans:', data)
        this.listData = data.data
      } catch (error) {
        console.error('Error:', error)
      } finally {
        this.loading = false
      }
    },
    async getMySubscriptionList () {
      this.subscriptionLoading = true
      try {
        // var { data } = await RestApi.getData(baseURL, 'ios/getSubscriptionPlanList')
        var { data } = await RestApi.getData(apiBaseURL, 'admin/ajax/get_my_subscription_plan_list')
        // console.log('Subscription Plans:', data)
        this.mySubscriptionList = data.list
        console.log('My Subscription List:', this.mySubscriptionList)
      } catch (error) {
        console.error('Error:', error)
      } finally {
        this.subscriptionLoading = false
      }
    },
    goToPayment (planId) {
      const query = this.$route.query
      query.plan_id = planId
      // Navigate to payment page with the plan ID
      this.$router.push({ name: 'UserPaymentDetails', query: query })
    }
  }
}
</script>

<style scoped>
.btn-transparent {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
.btn-transparent:hover {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
.btn-transparent:focus {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
.btn-transparent:active {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
.btn-light-transparent {
  background-color: rgba(255, 255, 255, 0.262);
  border: none;
  box-shadow: none;
}
.btn-light-transparent:hover {
  background-color: rgba(255, 255, 255, 0.425);
  border: none;
  box-shadow: none;
}
.btn-outline-light {
  border-color: rgba(255, 255, 255, 0.7);
}
.btn-outline-light:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 1);
}
</style>
